import { combineReducers } from '@reduxjs/toolkit';
import cartReducers from './slices/cartSlice';
import productReducers from './slices/productsSlice';

export const rootReducer = combineReducers({ products: productReducers, cart: cartReducers });
